<template>
	<div class="the_layout">
		<div class="the_layout_wrap">
			<Header/>
			<div class="layout_bottom">		
				<Aside/>
				<Main/>
			</div>
		</div>
	</div>
</template>
<script>
	import Header from './header'
	import Aside from './aside'
	import Main from './main'
	export default{
		name:'Layout',
		components:{
			Header,
			Aside,
			Main,
		},
		data(){
			return{

			}
		}
	}
</script>
<style lang='scss' scoped>
	.the_layout{
		// border: 5px solid #f00;
		box-sizing: border-box;
		height: 100vh;
		width: 100%;
		overflow: hidden;
		.the_layout_wrap{
			display: flex;
			flex-direction: column;
			width: 100%;
			height: 100%;
			.layout_bottom{
				flex-grow: 1;
				box-sizing: border-box;
				overflow: hidden;
				display: flex;
			}
		}
	}
</style>